/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ListJobsSortDir = typeof ListJobsSortDir[keyof typeof ListJobsSortDir];


export const ListJobsSortDir = {
  asc: 'asc',
  desc: 'desc',
} as const;
